import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { StoreSelection, Store } from '../../models/store';
import { MatBottomSheet, MatBottomSheetConfig, MatDialog } from '@angular/material';
import { StoreService } from '../../services/store.service';
import { StoreSelectorService } from '../../services/storeselector.service';
import { StoreSelectorComponent } from '../store-selector/store-selector.component';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { NotificationsDialogComponent } from './notifications-dialog/notifications-dialog.component';
import { ChangePasswordDialogComponent } from '../change-password/change-password-dialog.component';

const EMPTY_SELECTED_STORE: StoreSelection = { storeGuid: "", name: "" };

@Component({
	selector: 'shell',
	templateUrl: './shell.component.html',
	styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit, OnDestroy {
	isHandset: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset);

	currentUsername: string;
	stores: Store[] = [];
	isStoreHoursVisible: boolean = false;

	constructor(private _authService: AuthService,
		private _storeService: StoreService,
		private _storeSelectorService: StoreSelectorService,
		private breakpointObserver: BreakpointObserver,
		private storeSelector: MatBottomSheet,
		private router: Router,
		private dialog: MatDialog) {
		_authService.userLoadedEvent.subscribe((user: any) => {
			this.currentUsername = user.profile.name;
			this.isStoreHoursVisible = _authService.IsSuperuser();
		});
	}

	// The currently selected store - shown in UI 
	selectedStore: StoreSelection = EMPTY_SELECTED_STORE;

	private selectedStoreChangesSubscription: Subscription;

	// Set Selected Store to update Toolbar
	private setSelectedStore(newSelectedStore: StoreSelection) {
		if (newSelectedStore === null) {
			this.selectedStore = EMPTY_SELECTED_STORE;
			if (this.stores.length > 1)
				this.openStoreSelectorNotCloseable();
		}
		else {
			this.selectedStore = newSelectedStore;
		}
	}

	// Subscribe to StoreSelector updates, updating toolbar 'Selected Store' when new Store is selected
	ngOnInit() {
		// Update Selected Store UI when selected store changes
		this.selectedStoreChangesSubscription = this._storeSelectorService.storeChanges.subscribe((newSelectedStore: StoreSelection) => {
			this.setSelectedStore(newSelectedStore);
		});

		//get list of stores
		this.getStores();
	}

	getStores() {
		this._storeService.getStores().then((storeRequest: Observable<Store[]>) => {
			storeRequest.subscribe((stores: Store[]) => {
				this.stores = stores;

				// Get Store from Local Storage
				let initSelectedStore: StoreSelection = this._storeSelectorService.getSelectedStore();
				if (this.stores == null)
					this._storeSelectorService.setSelectedStore(null);
				else if (this.stores.length == 1)
					this._storeSelectorService.setSelectedStore(this.stores[0]);
				else
					this.setSelectedStore(initSelectedStore);
			}, err => {
				console.error(err);
				this.stores = [];
			})
		})
	}

	// Properly dispose of Store Changes Subscription
	ngOnDestroy() {
		this.selectedStoreChangesSubscription.unsubscribe();
	}

	// Opens a Store Selector but it cannot be closed until a store is selected
	// Can't have a null selected store, so we force the user to select one before continuing
	openStoreSelectorNotCloseable(): void {
		let config: MatBottomSheetConfig = new MatBottomSheetConfig;
		config.disableClose = true;
		setTimeout(() => {
			this.storeSelector.open(StoreSelectorComponent, config);
		})
	}

	// Opens a Store Selector with no restrictions
	openStoreSelector(): void {
		setTimeout(() => {
			this.storeSelector.open(StoreSelectorComponent);
		})
	}

	openNotificationsDialog(): void {
		this.dialog.open(NotificationsDialogComponent, {
			data: { store: this.selectedStore },
			minWidth: "350px",
			width: "80vh",
			maxWidth: "700px",
		});
	}

	// More Options Menu Item - Logoff
	logout(): void {
		this._authService.Logoff();
	}

	changePassword(): void {
		let dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
			minWidth: "350px",
			width: "50vh",
			maxWidth: "700px",
			data: { title: "Change Password" }
		});
	}
}
